import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';

import Header from 'containers/PasswordRecoveryPages/Header';
import messages from 'containers/PasswordRecoveryPages/PasswordRecoveryOptions/messages';
import { translate } from 'helpers/intl';
import Form from 'containers/PasswordRecoveryPages/PasswordRecoveryOptions/form';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import {
  getHashedEmailSelector,
  getIsQuestionSelector,
  getIsEmailSelector,
  getIsPhoneSelector,
  getHashedPhoneSelector,
} from 'store/credentials/selectors';

const PasswordRecoveryOptions = (props: {
  hashedEmail: string;
  hashedPhone: string;
  intl: IntlShape;
  isLoading: boolean;
  onSubmitStep: Function;
  showQuestionOption: boolean;
  showEmailOption: boolean;
  showPhoneOption: boolean;
}) => (
  <React.Fragment>
    <Header
      title={translate({ ...messages.formTitle }, props)}
      subTitle={translate({ ...messages.formSubTitle }, props)}
    />
    <Form
      isLoading={props.isLoading}
      onSubmit={props.onSubmitStep}
      hashedEmail={props.hashedEmail}
      hashedPhone={props.hashedPhone}
      showEmailOption={props.showEmailOption}
      showPhoneOption={props.showPhoneOption}
      showQuestionOption={props.showQuestionOption}
    />
  </React.Fragment>
);

const mapStateToProps = createStructuredSelector<
  any,
  {
    hashedEmail: string;
    hashedPhone: string;
    showQuestionOption: boolean;
    showEmailOption: boolean;
    showPhoneOption: boolean;
  }
>({
  hashedPhone: getHashedPhoneSelector,
  hashedEmail: getHashedEmailSelector,
  showQuestionOption: getIsQuestionSelector,
  showEmailOption: getIsEmailSelector,
  showPhoneOption: getIsPhoneSelector,
});
export default connect(mapStateToProps)(injectIntl(PasswordRecoveryOptions));
